// extracted by mini-css-extract-plugin
export var backButton = "styles_backButton__XaD7H";
export var detailsContainer = "styles_detailsContainer__nC+Xl";
export var orderDetails = "styles_orderDetails__ypONj";
export var shipments = "styles_shipments__Ric3w";
export var title = "styles_title__cUwYZ";